import React from 'react';
import { Link } from 'react-router-dom';

const EmptyState = ({ message, linkText, linkTo, icon }) => {
  return (
    <div className="col-span-full flex flex-col items-center justify-center py-20 text-center">
      {icon && (
        <div className="text-[#F2B705] mb-5 text-6xl">
          {icon}
        </div>
      )}

      <p
        className="text-[#1B1B1F] text-2xl font-bold mb-3"
        style={{ fontFamily: "'Baloo Bhaijaan 2', sans-serif" }}
      >
        {message}
      </p>

      <p className="text-gray-500 mb-6 max-w-md">
        لا توجد بيانات متاحة حاليًا.
      </p>

      <Link
        to={linkTo}
        className="bg-[#F2B705] hover:bg-[#1B1B1F] text-[#1B1B1F] hover:text-white
        font-bold py-3 px-6 rounded-full transition-colors duration-300
        focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#F2B705]
        focus-visible:ring-offset-2"
      >
        {linkText}
      </Link>
    </div>
  );
};

export default EmptyState;
